<div class="panel-shell">
  <header class="panel-header primary">
    <div class="panel-title text-bold">
      {{ "CONVERT_SUBMISSION.TITLE" | translate }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <!-- SUMMARY OF THE SUBMISSION -->
    <div class="cs-summary">
      <div class="text-bold">{{ submission.full_name }}</div>
      <div>{{ submission.email }}<span *ngIf="submission.tel"> · {{ submission.tel }}</span></div>
      <div *ngIf="submission.event_time || submission.guest_count" class="cs-summary-hint">
        <span *ngIf="submission.event_time">{{ "CONVERT_SUBMISSION.REQUESTED_TIME" | translate }}: {{ submission.event_time }}</span>
        <span *ngIf="submission.event_time && submission.guest_count"> · </span>
        <span *ngIf="submission.guest_count">{{ "CONVERT_SUBMISSION.REQUESTED_GUESTS" | translate }}: {{ submission.guest_count }}</span>
      </div>
    </div>

    <!-- DOCUMENT TYPE -->
    <div class="cs-section-title text-bold">
      {{ "CONVERT_SUBMISSION.DOCUMENT_TYPE" | translate }}
    </div>
    <mat-radio-group class="cs-radio-group" [(ngModel)]="documentType">
      <mat-radio-button class="cs-radio-button" value="PROPOSAL">
        <mat-icon class="s-18 mr-4">{{ getIcon("PROPOSAL") }}</mat-icon>
        {{ "CONVERT_SUBMISSION.TYPE_PROPOSAL" | translate }}
      </mat-radio-button>
      <mat-radio-button class="cs-radio-button" value="ORDER">
        <mat-icon class="s-18 mr-4">{{ getIcon("ORDER") }}</mat-icon>
        {{ "CONVERT_SUBMISSION.TYPE_ORDER" | translate }}
      </mat-radio-button>
    </mat-radio-group>

    <!-- BASE: name / date / start / end / guests -->
    <div [formGroup]="form" class="cs-flex-column">
      <mat-form-field class="cs-width" subscriptSizing="dynamic">
        <mat-label>{{ "GENERIC.NAME" | translate }}</mat-label>
        <input
          matInput
          formControlName="name"
          type="text"
          autocomplete="nope"
          [(ngModel)]="event.name"
          required
        />
        <mat-error *ngIf="form.controls['name'].invalid">{{
          "GENERIC.INPUT_LENGTH_INVALID" | translate
        }}</mat-error>
      </mat-form-field>

      <div class="date-field-wrapper cs-width">
        <div class="timepicker-custom-label">
          {{ "GENERIC.DATE" | translate }}*
        </div>
        <mat-form-field class="cs-width">
          <input
            matInput
            [matDatepicker]="datePicker"
            [(ngModel)]="event.event_date"
            (dateChange)="onDatePickerChange($event)"
            min="1900-01-01"
            formControlName="event_date"
          />
          <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
          <mat-datepicker #datePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="cs-width cs-time-field">
        <div class="timepicker-custom-label">
          {{ "GENERIC.TIME_START" | translate }}*
        </div>
        <ngx-timepicker-field
          [buttonAlign]="'left'"
          [format]="24"
          [(ngModel)]="event.event_time"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onStartTimeChange($event)"
        ></ngx-timepicker-field>
      </div>

      <div class="cs-width time-end-row">
        <button
          mat-stroked-button
          type="button"
          color="primary"
          class="add-hours-btn"
          (click)="addThreeHoursToEndTime()"
          [disabled]="!startTimeSelected"
          tabindex="-1"
        >
          +3h
        </button>
        <div class="time-end-field">
          <div class="timepicker-custom-label">
            {{ "GENERIC.TIME_END" | translate }}
          </div>
          <ngx-timepicker-field
            [buttonAlign]="'left'"
            [format]="24"
            [(ngModel)]="event.event_time_end"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onEndTimeChange($event)"
          ></ngx-timepicker-field>
        </div>
      </div>

      <mat-form-field class="cs-width" subscriptSizing="dynamic">
        <mat-label>{{ "CONVERT_SUBMISSION.GUEST_COUNT" | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          autocomplete="nope"
          [(ngModel)]="event.guest_count"
          [ngModelOptions]="{ standalone: true }"
        />
      </mat-form-field>
    </div>

    <!-- CONSEILLER -->
    <div class="cs-section-title text-bold">
      {{ "CONVERT_SUBMISSION.RESPONSIBLE_EMPLOYEE" | translate }}
    </div>
    <div class="cs-width">
      <app-gt2-select
        [service]="conseillersService"
        [placeHolder]="'CONVERT_SUBMISSION.SELECT_RESPONSIBLE_EMPLOYEE' | translate"
        [label]="'Conseiller'"
        [selectedModel]="responsibleEmployee"
        (changeEvent)="onResponsibleEmployeeSelected($event)"
        [noResultsLabel]="translate.instant('GENERIC.NO_RESULTS')"
        [nullableUseNone]="true"
      ></app-gt2-select>
      <div class="cs-hint">{{ "CONVERT_SUBMISSION.RESPONSIBLE_EMPLOYEE_HINT" | translate }}</div>
    </div>

    <!-- CLIENT -->
    <div class="cs-section-title text-bold">
      {{ "CONVERT_SUBMISSION.CLIENT" | translate }}
    </div>
    <mat-radio-group class="cs-radio-group" [(ngModel)]="clientMode">
      <mat-radio-button
        *ngIf="submission.client_match"
        class="cs-radio-button"
        value="match"
      >
        {{ "CONVERT_SUBMISSION.CLIENT_MATCH" | translate }}
        <span class="text-bold">{{ submission.client_match.full_name }}</span>
      </mat-radio-button>
      <mat-radio-button class="cs-radio-button" value="create">
        {{ "CONVERT_SUBMISSION.CLIENT_CREATE" | translate }}
        <span class="text-bold">{{ submission.full_name }}</span>
      </mat-radio-button>
      <mat-radio-button class="cs-radio-button" value="choose">
        {{ "CONVERT_SUBMISSION.CLIENT_CHOOSE" | translate }}
      </mat-radio-button>
    </mat-radio-group>

    <mat-form-field
      *ngIf="clientMode === 'choose'"
      class="cs-width"
      subscriptSizing="dynamic"
    >
      <mat-label>{{ "CONVERT_SUBMISSION.SEARCH_CLIENT" | translate }}</mat-label>
      <input
        matInput
        type="text"
        autocomplete="nope"
        [formControl]="clientSearchCtrl"
        [matAutocomplete]="clientAuto"
        (input)="onClientInput(clientSearchCtrl.value)"
      />
      <mat-spinner *ngIf="clientSearching" matSuffix [diameter]="18"></mat-spinner>
      <button
        *ngIf="chosenClient && !clientSearching"
        mat-icon-button
        matSuffix
        type="button"
        aria-label="Clear"
        (click)="clearChosenClient()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete
        #clientAuto="matAutocomplete"
        [displayWith]="displayClient"
        (optionSelected)="onClientSelected($event.option.value)"
      >
        <mat-option *ngFor="let item of clientResults" [value]="item">
          {{ item.name_label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div class="cs-hint">{{ "CONVERT_SUBMISSION.NOTE_HINT" | translate }}</div>

    <div *ngIf="loading" class="cs-flex-row-center">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      mat-raised-button
      color="accent"
      type="button"
      class="mr-8 ml-8 mt-4 mb-4"
      [disabled]="!canSave"
      (click)="onSave()"
    >
      {{ "CONVERT_SUBMISSION.CONVERT" | translate }}
    </button>
    <button
      mat-raised-button
      type="button"
      class="mr-8 ml-8 mt-4 mb-4 primary"
      (click)="close()"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
